<template>
  <div class="text-center">
    <v-dialog
      v-model="getErrorMessage"     
      width="500"
    >     
      <v-card>
        <v-card-title class="headline grey lighten-2">
          Error Message
        </v-card-title>

        <v-card-text>
          {{ getErrorMessage }}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="dismiss"
          >
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  export default {
    data () {
      return {      
        errorMessage: this.getErrorMessage,
      }
    },   
    methods: {
        dismiss() {           
            this.setErrorMessage('')
        },
        ...mapActions([
            'setErrorMessage'
        ])
    },
    computed: {
		...mapGetters([
			'getErrorMessage',			
		])
    }
  }
</script>